export const GET_CONTENT = "GET_CONTENT";
export const GET_CONTENT_SUCCESS = "GET_CONTENT_SUCCESS";
export const GET_CONTENT_ERROR = "GET_CONTENT_ERROR";
export const GET_CONTENT_BAD_SECTION_REQUEST =
  "GET_CONTENT_BAD_SECTION_REQUEST";
export const GET_SECTION = "GET_SECTION";
export const GET_SECTION_SUCCESS = "GET_SECTION_SUCCESS";
export const GET_SECTION_ERROR = "GET_SECTION_ERROR";
export const GET_SECTION_LOAD_EXISTING = "GET_SECTION_LOAD_EXISTING";
export const GET_DETAILS_SECTION = "GET_DETAILS_SECTION";
export const GET_DETAILS_SECTION_SUCCESS = "GET_DETAILS_SECTION_SUCCESS";
export const GET_DETAILS_SECTION_ERROR = "GET_DETAILS_SECTION_ERROR";
export const GET_DETAILS_SECTION_LOAD_EXISTING =
  "GET_DETAILS_SECTION_LOAD_EXISTING";
export const GET_PRINT_SECTIONS = "GET_PRINT_SECTIONS";
export const GET_PRINT_SECTIONS_SUCCESS = "GET_PRINT_SECTIONS_SUCCESS";
export const GET_PRINT_SECTIONS_ERROR = "GET_PRINT_SECTIONS_ERROR";
export const GET_PRINT_DETAILS_SECTIONS = "GET_PRINT_DETAILS_SECTIONS";
export const GET_PRINT_DETAILS_SECTIONS_SUCCESS =
  "GET_PRINT_DETAILS_SECTIONS_SUCCESS";
export const GET_PRINT_DETAILS_SECTIONS_ERROR =
  "GET_PRINT_DETAILS_SECTIONS_ERROR";
export const SET_ACTIVE_TOC_ITEM = "SET_ACTIVE_TOC_ITEM";
export const SHOW_ERROR = "SHOW_ERROR";
export const HIDE_ERROR = "HIDE_ERROR";
export const DRUG_MOBILE_TOC_SET_TAB = "DRUG_MOBILE_TOC_SET_TAB";
//user activity tracking
export const COLLECT_ITEM_VIEWS_EVENT = "COLLECT_ITEM_VIEWS_EVENT";
export const POST_ITEM_VIEWS = "POST_ITEM_VIEWS";
export const POST_ITEM_VIEWS_SUCCESS = "POST_ITEM_VIEWS_SUCCESS";
export const POST_ITEM_VIEWS_ERROR = "POST_ITEM_VIEWS_ERROR";
export const SET_ACTIVE_VIDEO = "SET_ACTIVE_VIDEO";
//Full Text Links
export const GET_FT_LINKS_SUCCESS = "GET_FT_LINKS_SUCCESS";
export const GET_FT_LINKS_ERROR = "GET_FT_LINKS_ERROR";
export const GET_FT_LINKS = "GET_FT_LINKS";
//Bookmark content
export const PUT_CONTENT_BOOKMARK = "PUT_CONTENT_BOOKMARK";
export const PUT_CONTENT_BOOKMARK_SUCCESS = "PUT_CONTENT_BOOKMARK_SUCCESS";
export const PUT_CONTENT_BOOKMARK_ERROR = "PUT_CONTENT_BOOKMARK_ERROR";
export const DELETE_CONTENT_BOOKMARK = "DELETE_CONTENT_BOOKMARK";
export const DELETE_CONTENT_BOOKMARK_SUCCESS =
  "DELETE_CONTENT_BOOKMARK_SUCCESS";
export const DELETE_CONTENT_BOOKMARK_ERROR = "DELETE_CONTENT_BOOKMARK_ERROR";
//Follow content
export const PUT_CONTENT_FOLLOW = "PUT_CONTENT_FOLLOW";
export const PUT_CONTENT_FOLLOW_SUCCESS = "PUT_CONTENT_FOLLOW_SUCCESS";
export const PUT_CONTENT_FOLLOW_ERROR = "PUT_CONTENT_FOLLOW_ERROR";
export const DELETE_CONTENT_FOLLOW = "DELETE_CONTENT_FOLLOW";
export const DELETE_CONTENT_FOLLOW_SUCCESS = "DELETE_CONTENT_FOLLOW_SUCCESS";
export const DELETE_CONTENT_FOLLOW_ERROR = "DELETE_CONTENT_FOLLOW_ERROR";
//Notification
export const ADD_CONTENT_NOTIFICATION = "ADD_CONTENT_NOTIFICATION";
export const CLEAR_CONTENT_NOTIFICATION = "CLEAR_CONTENT_NOTIFICATION";
//Copy to clipboard
export const COPY_TO_CLIPBOARD_SUCCESS = "COPY_TO_CLIPBOARD_SUCCESS";
export const COPY_TO_CLIPBOARD_ERROR = "COPY_TO_CLIPBOARD_ERROR";
export const GET_FULL_TOPIC = "GET_FULL_TOPIC";
export const MARK_FULL_TOPIC_LOADED = "MARK_FULL_TOPIC_LOADED";
export const GET_FULL_TOPIC_SUCCESS = "GET_FULL_TOPIC_SUCCESS";
export const GET_FULL_TOPIC_ERROR = "GET_FULL_TOPIC_ERROR";
export const PREPROCESS_FULL_TOPIC = "PREPROCESS_FULL_TOPIC";
export const PREPROCESS_FULL_TOPIC_SUCCESS = "PREPROCESS_FULL_TOPIC_SUCCESS";
export const PREPROCESS_FULL_TOPIC_ERROR = "PREPROCESS_FULL_TOPIC_ERROR";
export const CLEAR_FULL_TOPIC_ERROR = "CLEAR_FULL_TOPIC_ERROR";
export const GET_ALL_SECTIONS_SUCCESS = "GET_ALL_SECTIONS_SUCCESS";
export const GET_ALL_SECTIONS_ERROR = "GET_ALL_SECTIONS_ERROR";
export const GET_SHARE_DATA = "GET_SHARE_DATA";
export const GET_SHARE_DATA_SUCCESS = "GET_SHARE_DATA_SUCCESS";
export const GET_SHARE_DATA_ERROR = "GET_SHARE_DATA_ERROR";

export const SAVE_CLOUDINARY_TOKEN = "SAVE_CLOUDINARY_TOKEN";
export const GET_MERATIVE_LINK_WITH_TOKEN_SUCCESS =
  "GET_MERATIVE_LINK_WITH_TOKEN_SUCCESS";
export const GET_MERATIVE_LINK_WITH_TOKEN_ERROR =
  "GET_MERATIVE_LINK_WITH_TOKEN_ERROR";
export const CLEAR_MERATIVE_LINK_WITH_TOKEN = "CLEAR_MERATIVE_LINK_WITH_TOKEN";

export const INITIALIZE_STORE = "INITIALIZE_STORE";
